import styled from "styled-components";

import { Modal, Table } from "src/components-v2";

import { colors, typography } from "src/assets/styles/settings";

export const TableStyled = styled(Table)`
  border: 1px solid ${colors.light_smoke};
  border-radius: 10px;
  margin-bottom: 15px;

  thead > tr > th {
    background-color: #223547;
    padding: 20px;
    color: ${colors.white};
    white-space: nowrap;

    .c-tooltip {
      max-width: 300px;
    }
    .c-tooltip--top {
      opacity: 1;
    }
    .c-tooltip__arrow {
      border-top-color: ${colors.white};
    }
    .c-tooltip__label {
      background-color: ${colors.white};
      color: black;
    }

    svg {
      color: #a9a9a9;
    }

    &:first-child {
      border-radius: 10px 0 0 0;
    }
    &:last-child {
      border-radius: 0 10px 0 0;
    }
  }
  tbody > tr {
    &:nth-child(even) {
      td {
        background-color: ${colors.white};
      }
    }

    &:nth-child(even) {
      td {
        background-color: ${colors.table_stripe};
      }
    }

    td:first-child {
      font-weight: ${typography.font_weight.bold};
    }

    &:last-child {
      td:first-child {
        border-radius: 0 0 0 10px;
      }
      td:last-child {
        border-radius: 0 0 10px;
      }
    }

    td {
      padding: 20px;
      ol {
        padding-left: 12px;
      }
      ul,
      li {
        margin: 0;
        padding: 0;

        span {
          position: relative;
          left: 8px;
        }
      }
    }
  }
`;

export const ModalStyled = styled(Modal)`
  .custom-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background-color: ${colors.white};
    padding: 14px 14px 8px 14px;
    border-radius: 5px 5px 0 0;

    span:last-child {
      color: ${colors.light_grey};
    }
  }

  .c-modal__dialog {
    padding: 0 14px;
    overflow: hidden;
    max-width: 1200px;
  }

  .c-modal__body {
    ::-webkit-scrollbar {
      height: 8px;
      width: 8px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 1ex;
      -webkit-border-radius: 1ex;
    }

    > div {
      padding: 0;
    }
  }
`;
